import React from 'react';
import { Button } from '../../../shared/ui/button';
import { useHistory } from 'react-router-dom';
import { mpCardRoutes } from '../../../../common/mpCardRoutes';
import refresh from '../../../../assets/refresh.svg';
import Tooltip from '@material-ui/core/Tooltip';

interface CardMoveButtonProps {
  isActive: boolean;
}

export const CardMoveButton = ({ isActive }: CardMoveButtonProps) => {
  const history = useHistory();

  const handleClick = () => {
    if (isActive) {
      history.push(mpCardRoutes.moveCards.route({}));
    }
  };

  const button = (
    <Button
      icon={refresh}
      onClick={handleClick}
      width={168}
      className={!isActive ? 'btn_outline' : undefined}
    >
      Переместить
    </Button>
  );

  return isActive ? (
    button
  ) : (
    <Tooltip title="Выберите карточки для перемещения" arrow>
      <span>{button}</span>
    </Tooltip>
  );
};
